//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableIntBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[1,"AdjustRegister",0,"CAM.InheritableIntBuilder",0],[0,"AdjustRegisterToggle",1,0],[1,"Angle",0,"CAM.InheritableDoubleBuilder",0],[0,"AngleToggle",1,0],[1,"CutcomRegister",0,"CAM.InheritableIntBuilder",0],[0,"CutcomRegisterToggle",1,0],[0,"HeadDesignation",1,0],[1,"HolderNumber",0,"CAM.InheritableIntBuilder",0],[0,"HolderToggle",1,0],[0,"ManualToolChange",1,0],[1,"Number",0,"CAM.InheritableIntBuilder",0],[0,"NumberToggle",1,0],[1,"Radius",0,"CAM.InheritableDoubleBuilder",0],[0,"RadiusToggle",1,0],[0,"TextToggle",1,0],[0,"TextValue",1,0],[1,"Xoffset",0,"CAM.InheritableDoubleBuilder",0],[0,"XoffsetToggle",1,0],[1,"Yoffset",0,"CAM.InheritableDoubleBuilder",0],[0,"YoffsetToggle",1,0],[1,"Zoffset",0,"CAM.InheritableDoubleBuilder",0],[0,"ZoffsetToggle",1,0]],[],[]];
SPLM.CAM.ToolChangeCiBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolChangeCiBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolChangeCiBuilder.HeadDesignationTypes = Object.freeze({
    "None" : "None", "Front" : "Front", "Rear" : "Rear", "Right" : "Right", "Left" : "Left", "Side" : "Side", "Saddle" : "Saddle"});

export default SPLM;